import Vue from "vue";
import Vuex from "vuex";

import * as modules from "@/store/modules";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
  modules,
  plugins: [createPersistedState()],
});
